import { authRoutes } from "@saas/config/shared/auth-routes/auth-routes";

export type PublicRoutes = ReadonlyArray<string>;

export const publicRoutes: PublicRoutes = ["/public", ...authRoutes];

export default publicRoutes;
